import React, {useEffect} from "react";
import PropTypes from "prop-types";
// Librairie
import {Route, Switch, withRouter} from "react-router-dom";
import {Elements} from "@stripe/react-stripe-js";
// Containers
import Home from "../../containers/Home";
import PlanDemand from "../../containers/Chat/ChatBot/PlanDemand";
import Redirection from "../../containers/Redirection";
import Case from "../../containers/Chat/ChatCase/ChatCase";
import Pap from "../../containers/Pap";
import FreeQuestionChatBot from "../../containers/Chat/ChatBotFreeQuestion/ChatBotFreeQuestion/index";
import YourQuestion from "../../containers/Home/Pages/YourQuestions";
import PrivateRoutes from "../../containers/App/PrivateRoutes";
// Composants
import Alerte from "../Chat/shared/Alerte/Alerte";
import OnBoarding from "../OnBoarding/OnBoarding";
// Assets
import Error from "../../assets/icons/error.svg";
// Utils
import {getUrlParam} from "../../utils/getUrlParam";
import {loadStripeApiKey} from "../../utils/getStripeApiKey";


const App = ({
                 checkIsLogged,
                 getCases,
                 redirection,
                 errorApiMessage,
                 getSouscription,
             }) => {
// S'il y a un paramètre "offres-familles", on saute l'étape du code d'activation en stockant l'info dans le localStorage
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const offresFamilles = urlParams.get("option");
        if (offresFamilles === "offres-familles") {
            localStorage.setItem("offres-familles", "true");
        }
    });

    useEffect(() => {
// checkLoginFirst redirige depuis le module login vers la messagerie
        async function checkLoginFirst() {
// Récupération des paramètres de sessions sont envoyé en get
            let id = getUrlParam("id");
            let idUser = getUrlParam("idUser");
            let email = getUrlParam("email");
            if (id !== null && idUser !== null && email !== null) {
                window.localStorage.setItem("id", id);
                window.localStorage.setItem("idUser", idUser);
                window.localStorage.setItem("email", email);
            }
// Ces middlewares SEMBLENT récupérer le storage pour vérifier la présence des paramètres
            await checkIsLogged();
            await getCases();
            await getSouscription();
        }

        checkLoginFirst().then((res) => res);
    }, []);

    return (
        <div className="App">
            {errorApiMessage &&
                <Alerte text={"Une erreur s'est produite. Veuillez réessayer."} activeClass={"error"} src={Error}/>
            }
            {!redirection &&
                // Elements permet de pouvoir utiliser les hooks useStripe et useElement
                // présent dans les composants Checkout (src/component/Home/OfferModal/Stripe)
                // et qui font trigger le PaymentElement
                <Elements stripe={loadStripeApiKey()}>
                    <Switch>
                        <Route exact path={"/"} component={Home}/>
                        <PrivateRoutes exact path={"/conversation"} component={PlanDemand}/>
                        <Route exact path={"/case/:id"} component={({match}) => (
                            <>
                                <Case id={match.params.id}/>
                            </>
                        )}/>
                        <Route exact path={"/pap/:id"} component={({match}) => (
                            <>
                                <Pap id={match.params.id}/>
                            </>
                        )}/>
                        <Route exact path={"/onboarding"} component={OnBoarding}/>
                        <Route exact path={"/free-question"} component={FreeQuestionChatBot}/>
                        <Route exact path={"/vos-questions"} component={YourQuestion}/>
                        <Route exact path={"/question/:id"} component={({match}) => (
                            <>
                                <YourQuestion id={match.params.id}/>
                            </>
                        )}/>
                    </Switch>
                </Elements>
            }
            {redirection &&
                <Redirection/>
            }
        </div>
    );
};

App.propTypes = {
    redirection: PropTypes.bool,
    checkIsLogged: PropTypes.func,
    getCases: PropTypes.func,
    setShowModal: PropTypes.func,
    getSouscription: PropTypes.func,
    loading: PropTypes.bool,
    showModal: PropTypes.bool,
    errorApiMessage: PropTypes.bool,
};


export default withRouter(App);
